var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-preview-system"},[(_vm.loaded)?_c('router-view'):(!_vm.errorModalCode)?_c('SystemLoader'):_vm._e(),(_vm.errorModalCode)?_c('ErrorModal',{attrs:{"type":_vm.loaded ? 'order' : 'generic',"code":_vm.errorModalCode},on:{"close":function($event){_vm.errorModalCode = null}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }